<template>
  <div class="big_box">
    <report-table-children
      :api-config="apiConfig"
      :date-field="'billDateRange'"
      data-key="data"
      :show-pagination="true"
      report-key="PurifyDailyRpt"
      filterMode="drawer"
    />
  </div>
</template>

<script>
import { apiPurifyDailyRpt, apiPurifyDailyRptPull, apiPurifyDailyRptExport } from '@/request/api';

export default {
  name: 'PurifyDailyRpt',
  data() {
    return {
      apiConfig: {
        pull: apiPurifyDailyRptPull,
        getData: apiPurifyDailyRpt,
        exportData: apiPurifyDailyRptExport
      }
    };
  }
};
</script>

<style  lang="scss" scoped>
</style>
